import LxtLogo from 'assets/images/lxt-logo.png';
import SwagbucksLogo from 'assets/images/swagbucks-logo.png';
import OutlierLogo from 'assets/images/outlier-logo.png';
import AppenLogo from 'assets/images/appen-logo.png';
import { Trans, useTranslation } from 'react-i18next';
import { IconModal, Button } from '@airtm/airtm-ui';

export default function USAWarningModal({
  onClose,
  onAccept,
}: Readonly<{ onClose: () => void; onAccept: () => void }>) {
  const { t } = useTranslation(['SIGNUP', 'STATIC']);

  return (
    <IconModal show>
      <IconModal.Body title={t('SIGNUP:US_USER_WARNING_MESSAGE_TITLE')} className="u-py-0">
        <div className="d-flex flex-column flex-gap-24">
          <div className="d-flex flex-column flex-md-row flex-gap-24">
            <div className="d-flex align-items-center justify-content-around justify-content-md-between flex-basis-even">
              <img alt="swagbucks" src={SwagbucksLogo} />
              <img alt="appen" src={AppenLogo} />
            </div>
            <div className="d-flex align-items-center justify-content-around justify-content-md-between flex-basis-even">
              <img alt="outlier" src={OutlierLogo} />
              <img alt="lxt" src={LxtLogo} />
            </div>
          </div>
          <p className="u-m-0">
            <Trans
              i18nKey="SIGNUP:US_USER_WARNING_MESSAGE_DESCRIPTION"
              components={[
                <a
                  key="bridge-link"
                  className="link--dark text--underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.bridge.xyz/"
                >
                  Bridge
                </a>,
              ]}
            />
          </p>
        </div>
        <IconModal.Actions className="u-px-0">
          <div className="d-flex flex-column justify-content-between w-100 flex-gap-16">
            <Button block onClick={onAccept}>
              {t('SIGNUP:US_USER_WARNING_MESSAGE_CTA')}
            </Button>
            <Button block className="u-m-0" variant="secondary" onClick={onClose}>
              {t('STATIC:GO_BACK')}
            </Button>
          </div>
        </IconModal.Actions>
      </IconModal.Body>
    </IconModal>
  );
}
